import {Decoder, field, number, object, string} from 'json-bouncer'
import {LocalDateTime} from 'js-joda'
import {localDateTimeDecoder} from '../Data/DecodeHelper'

export interface Parcel {
    readonly id: number
    readonly trackingNumber: string
    readonly created: LocalDateTime
}

export function parcelDecoder(): Decoder<Parcel> {
    return object({
        id: field('id', number()),
        trackingNumber: field('trackingNumber', string()),
        created: field('created', localDateTimeDecoder()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/Parcel.ts